export default [{
        path: '/travelAgency/info',
        meta: {
            title: '旅行社'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchtrinfo" */
                '../../pages/travelAgency/travelAgencyInfo.vue'
            )
    },
    {
        path: '/travelAgency/home',
        name: 'TravelAgencyHome',
        meta: {
            title: '旅行社',
            keepAlive: true
        },
        component: () =>
            import (
                /* webpackChunkName: "purtrhome" */
                '../../pages/travelAgency/travelAgencyHome.vue'
            )
    },
    {
        path: '/travelAgency/list',
        meta: {
            title: '旅行社'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchlist" */
                '../../pages/travelAgency/travelAgencyList.vue'
            )
    },
    {
        path: '/travelAgency/listNew',
        name: 'TravelAgencyListNew',
        meta: {
            title: '旅行社列表',
            keepAlive: true
        },
        component: () =>
            import (
                '../../pages/travelAgency/travelAgencyListNew.vue'
            )
    },
    {
        path: '/travelAgency/pendingList',
        meta: {
            title: '待办列表'
        },
        component: () =>
            import (
                '../../pages/travelAgency/travelAgencyPendingList.vue'
            )
    },
    {
        path: '/travelAgency/reviewHistoryList',
        meta: {
            title: '审批记录'
        },
        component: () =>
            import (
                '../../pages/travelAgency/reviewHistoryList.vue'
            )
    },
    {
        path: '/travelAgency/integrity',
        meta: {
            title: '评分详情'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchintegrity" */
                '../../pages/travelAgency/integrityIndex.vue'
            )
    },
    {
        path: '/travelAgency/blacklist',
        meta: {
            title: '黑名单监管明细'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchblacklist" */
                '../../pages/travelAgency/blacklistDisposal.vue'
            )
    },
    {
        path: '/travelAgency/registInfo',
        meta: {
            title: '注册信息'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchregistInfo" */
                '../../pages/travelAgency/registInfo.vue'
            )
    },
    {
        path: '/travelAgency/manageInfo',
        meta: {
            title: '经营信息'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchmanageInfo" */
                '../../pages/travelAgency/manageInfo.vue'
            )
    },
    {
        path: '/travelAgency/otherInfo',
        meta: {
            title: '其他信息'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchotherInfo" */
                '../../pages/travelAgency/otherInfo.vue'
            )
    },
    {
        path: '/travelAgency/companyPerson',
        meta: {
            title: '公司人员'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchcompanyPerson" */
                '../../pages/travelAgency/companyPerson.vue'
            )
    },
    {
        path: '/travelAgency/tourGuide',
        meta: {
            title: '签约导游'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchtourGuide" */
                '../../pages/travelAgency/tourGuide.vue'
            )
    },
    {
        path: '/travelAgency/documentPhoto',
        meta: {
            title: '证件照片'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchdocumentPhoto" */
                '../../pages/travelAgency/documentPhoto.vue'
            )
    },
    {
        path: '/travelAgency/complaintlList',
        meta: {
            title: '投诉列表'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchcomplaintlList" */
                '../../pages/travelAgency/complaintlList.vue'
            )
    },
    {
        path: '/travelAgency/personnelinfo',
        meta: {
            title: '人员信息'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchpersonnelinfo" */
                '../../pages/travelAgency/personnelinfo.vue'
            )
    },
    {
        path: '/travelAgency/travelItinerary',
        meta: {
            title: '行程单'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchtravelItinerary" */
                '../../pages/travelAgency/travelItinerary.vue'
            )
    },
    {
        path: '/travelAgency/tripDetail',
        meta: {
            title: '行程'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchtripDetail" */
                '../../pages/travelAgency/tripDetail.vue'
            )
    },
    {
        path: '/travelAgency/search',
        meta: {
            title: '旅行社'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchsearch" */
                '../../pages/travelAgency/search.vue'
            )
    },
    {
        path: '/travelAgency/todoList',
        meta: {
            title: '待办事项'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchtodoList" */
                '../../pages/travelAgency/todoList.vue'
            )
    },
    {
        path: '/travelAgency/travelRelatedPersonnel',
        meta: {
            title: '涉旅人员'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchtodoList" */
                '../../pages/travelAgency/travelRelatedPersonnel.vue'
            )
    },
    {
        path: '/travelAgency/enclosure',
        meta: {
            title: '附件'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchtodoList" */
                '../../pages/travelAgency/enclosure.vue'
            )
    },
    {
        path: '/travelAgency/failPass',
        meta: {
            title: '审核不通过'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchtodoList" */
                '../../pages/travelAgency/failPass.vue'
            )
    }
]
